export default {
    url: 'contact-us',
    include: ['us', 'za', 'jp', 'cn', 'ca', 'uk', 'au', 'de', 'fr', 'it', 'es', 'cis', 'sa', 'eu', 'ph'],
};
